'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect } from 'react';
import FinanceRepositorySetColumnConfig from '../../features/finance_repository/components/FinanceRepositorySetColumnConfig';
import { CommitHandler } from '../../features/finance_repository/CommitHandler';
import FinanceRepositoryActions from '../../features/finance_repository/components/FinanceRepositoryActions';
import { t } from '../../i18next';
import GridWrapper from '../../shared/components/grid/GridWrapper';

export default function FinanceRepositoryPage() {
  const { loading, error, screenTables } = useFetchScreenDetails('finance_repository');
  const parentTable = screenTables?.find(
    (item) => item.mbdDataGrid.dataGridInternalName == 'v_finance_repository',
  );
  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables ? null : (
            <GetAllColumnContextProvider>
              <FinanceRepository tableRes={parentTable} />
            </GetAllColumnContextProvider>
          )}
        </Layout>
      )}
    </>
  );
}

const FinanceRepository = (props) => {
  const { tableRes } = props;
  const { updateCustomConfig } = useColumnContextAPI();

  useEffect(() => {
    updateCustomConfig({
      CommitHandler,
      SetColumnConfig: FinanceRepositorySetColumnConfig,
      Actions: FinanceRepositoryActions,
    });
  }, []);
  return <GridWrapper tableRes={tableRes} />;
};
